export const SET_DOSSIER = "SET_DOSSIER";
export const SET_DOSSIER_LIST = "SET_DOSSIER_LIST";
export const SET_DATE_OF_BIRTH = "SET_DATE_OF_BIRTH";
export const UPDATE_DOSSIER = "UPDATE_DOSSIER";
export const AUTH_DOSSIER_LOGIN = "AUTH_DOSSIER_LOGIN";
export const AUTH_DOSSIER_CHECK = "AUTH_DOSSIER_CHECK";
export const AUTH_DOSSIER_LOGOUT = "AUTH_DOSSIER_LOGOUT";
export const SET_DOSSIER_LOADING = "SET_DOSSIER_LOADING";
export const SET_INVOICES = "SET_INVOICES";
export const SET_PAYMENT_LOADING = "SET_PAYMENT_LOADING";
export const SET_FAQS = "SET_FAQS";
export const SET_IS_SUBSCRIBED = "SET_IS_SUBSCRIBED";
export const SUBMIT_PAYMENT_ARRANGEMENT_REQUEST =
  "SUBMIT_PAYMENT_ARRANGEMENT_REQUEST";
export const UPDATE_DEBTOR_EMAIL = "UPDATE_DEBTOR_EMAIL";
